const DEVELOPER = [
  'dpfflsk45@gmail.com',
  'wkqkel@naver.com',
  'tosiltosilkk@gmail.com',
  'my__memoria@naver.com',
  'dkgueing@gmail.com',
  'yoojamer@gmail.com',
  'starberry970310@gmail.com',
  'skagygus8@gmail.com',
  'rlaqudwls157@gmail.com',
  'ejin1996@gmail.com',
]

export { DEVELOPER }
